import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import $ from "jquery";
import installDataTables from "datatables.net";
import installDataTablesBootstrap from "datatables.net-bs";
import installDataTablesScroller from "datatables.net-scroller";
import installDataTablesButtons from "datatables.net-buttons";
import installDataTablesButtonsBootstrap from "datatables.net-buttons-bs";
import installDataTablesButtonsColVis from "datatables.net-buttons/js/buttons.colVis.js";
import installDataTablesColReorder from "datatables.net-colreorder";
import "select2/dist/js/select2.full.min";
import "select2/dist/js/i18n/cs";
import "select2/dist/js/i18n/en";
import "spectrum-colorpicker/spectrum.js";
import "./legacy/startup";

function installJqueryPlugin(plugin: unknown) {
  if (typeof plugin === "function") {
    plugin(window, $);
  }
}

installJqueryPlugin(installDataTables);
installJqueryPlugin(installDataTablesBootstrap);
installJqueryPlugin(installDataTablesScroller);
installJqueryPlugin(installDataTablesButtons);
installJqueryPlugin(installDataTablesButtonsBootstrap);
installJqueryPlugin(installDataTablesButtonsColVis);
installJqueryPlugin(installDataTablesColReorder);

function LegacyShellApp() {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent("siisel:legacy-shell:mounted"));
  }, []);

  return null;
}

function mount() {
  if (document.getElementById("siisel-legacy-shell-root")) {
    return;
  }

  const root = document.createElement("div");
  root.id = "siisel-legacy-shell-root";
  root.hidden = true;
  document.body.appendChild(root);

  createRoot(root).render(
    <React.StrictMode>
      <LegacyShellApp />
    </React.StrictMode>
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount);
} else {
  mount();
}
